// extracted by mini-css-extract-plugin
export var label = "points-payment-checkbox-module--label--2a827";